import { NotFoundPage } from '@lingoda/fallbacks';
import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';
import { LinearProgress } from '@lingoda/ui';
import { LingobotPage } from './lazy';

export const LingobotPageProtected = () => {
    const featureFlag = useFeatureFlagValue(KameleoonFlagKey.lingobot);

    if (featureFlag.isLoading) {
        return <LinearProgress />;
    }

    if (!featureFlag.isVariant) {
        return <NotFoundPage />;
    }

    return <LingobotPage />;
};
